import { useTranslation, Trans } from 'react-i18next';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import InstagramEmbedComponent from '../../components/InstagramEmbedComponent';

function NewsWoofAndPaint() {
  const { t } = useTranslation();
  return (
    <div id="top">
      {/* <Preloader> */}
      {/* <Navbar /> */}
      <PageHeader
        title={t('newsPage.woofAndPaint.page')}
        page={t('newsPage.page')}
        pageUrl={'news'}
        subPage={t('newsPage.woofAndPaint.page')}
      />
      {/* <!-- ==== Page Content ==== --> */}
      <div className="page">
        <div className="container">
          <div className="row">
            {/* <!-- Post Content Column --> */}
            <div className="col-lg-8 col-xl-9 card blog-card">
              <div className="card-body">
                <h3 className="card-title">
                  {t('newsPage.woofAndPaint.title')}
                </h3>
                {/* <!-- Post info--> */}
                <div className="post-info border-irregular2 text-muted">
                  {' '}
                  Oktobar 2, 2025
                </div>
                <hr />
                {/* <!-- Preview Image --> */}
                <img src='/img/radionica.png' className="img-fluid" alt="" />
                <hr />
                {/* <!-- Post Content --> */}
                <p className="lead">{t('newsPage.woofAndPaint.excerpt')}</p>
                <p>{t('newsPage.woofAndPaint.post_content_1')}</p>
                <p>{t('newsPage.woofAndPaint.post_content_2')}</p>
                <p>{t('newsPage.woofAndPaint.post_content_3')}</p>
                <h4>{t('newsPage.woofAndPaint.post_content_4')}</h4>
                <p>{t('newsPage.woofAndPaint.post_content_5')}</p>
                <InstagramEmbedComponent  postId={'DPUPofGDcXq'}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NewsWoofAndPaint;
